import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { IComponentLoggingData } from "@faire/web-api--source/indigofair/data/IComponentLoggingData";
import { ISectionLoggingData } from "@faire/web-api--source/indigofair/data/ISectionLoggingData";
import { IViewLoggingData } from "@faire/web-api--source/indigofair/data/IViewLoggingData";
export var SectionLoggingEventParams;
(function(SectionLoggingEventParams) {
    SectionLoggingEventParams.build = function(partial) {
        return _object_spread({}, IViewLoggingData.build(partial), ISectionLoggingData.build(partial));
    };
})(SectionLoggingEventParams || (SectionLoggingEventParams = {}));
export var ComponentLoggingEventParams;
(function(ComponentLoggingEventParams) {
    ComponentLoggingEventParams.build = function(partial) {
        return _object_spread_props(_object_spread({}, SectionLoggingEventParams.build(partial), IComponentLoggingData.build(partial)), {
            component_id: partial === null || partial === void 0 ? void 0 : partial.component_id
        });
    };
})(ComponentLoggingEventParams || (ComponentLoggingEventParams = {}));
export var ActionLoggingEventParams;
(function(ActionLoggingEventParams) {
    ActionLoggingEventParams.build = function(partial) {
        return _object_spread_props(_object_spread({}, ComponentLoggingEventParams.build(partial)), {
            action_content: partial === null || partial === void 0 ? void 0 : partial.action_content,
            action_positions: partial === null || partial === void 0 ? void 0 : partial.action_positions,
            action_instance_identifier: partial === null || partial === void 0 ? void 0 : partial.action_instance_identifier
        });
    };
})(ActionLoggingEventParams || (ActionLoggingEventParams = {}));
